//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Features/Features.ShipDesign.DeckListBuilder.js";
import "../no/SelectNXObject.js";
import "../Drawings/Drawings.SelectDraftingView.js";
import "../Drawings/Drawings.ViewPlacementBuilder.js";
import "../Features/Features.ShipDesign.SelectStructuresBuilder.js";
import "../no/SelectModelingViewList.js";
import "../Drawings/Drawings.ViewStyleBuilder.js";
import "../no/Drawings.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"AlignmentType",1,0],[1,"Decks",0,"Features.ShipDesign.DeckListBuilder",0],[0,"DrawingSheet",1,"Drawings.DrawingSheet",0],[0,"EndFrame",1,"NXObject",0],[0,"EndFrameOffset",1,0],[1,"FrameAlignment",0,"SelectNXObject",0],[0,"InheritedPMISource",1,0],[1,"MasterView",0,"Drawings.SelectDraftingView",0],[1,"Placement",0,"Drawings.ViewPlacementBuilder",0],[0,"Scale",1,0],[1,"SelectStructures",0,"Features.ShipDesign.SelectStructuresBuilder",0],[1,"SelectedModelView",0,"SelectModelingViewList",0],[0,"SourcePart",1,"TaggedObject",0],[0,"StartFrame",1,"NXObject",0],[0,"StartFrameOffset",1,0],[0,"ViewCreation",1,0],[0,"ViewDirection",1,0],[0,"ViewName",1,0],[1,"ViewStyle",0,"Drawings.ViewStyleBuilder",0],[0,"ViewType",1,0]],[[["xPosition","yPosition"],"SetViewPosition",{},2,0],[["numModelViewNames","modelViewNames"],"GetSelectedModelViewNames",{},0,0],[["modelViewNames"],"SetSelectedModelViewNames",{},1,0]],[]];
SPLM.Features.ShipDesign.GeneralArrangementViewBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.GeneralArrangementViewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.GeneralArrangementViewBuilder.ViewDirectionType = Object.freeze({
    "XPositive" : "XPositive", "XNegative" : "XNegative", "YPositive" : "YPositive", "YNegative" : "YNegative", "ZPositive" : "ZPositive", "ZNegative" : "ZNegative", "Deck" : "Deck"});

SPLM.Features.ShipDesign.GeneralArrangementViewBuilder.ViewCreationType = Object.freeze({
    "ProjectView" : "ProjectView", "SectionView" : "SectionView"});

SPLM.Features.ShipDesign.GeneralArrangementViewBuilder.InheritedPMISourceOption = Object.freeze({
    "NoChange" : "NoChange", "None" : "None", "FromGARoot" : "FromGARoot", "FromGAContainer" : "FromGAContainer", "FromGADrawing" : "FromGADrawing", "FromDeckContainers" : "FromDeckContainers", "FromSourcePart" : "FromSourcePart"});

SPLM.Features.ShipDesign.GeneralArrangementViewBuilder.ViewAlignmentType = Object.freeze({
    "Frame" : "Frame", "Automatically" : "Automatically", "NoAlignment" : "NoAlignment"});

export default SPLM;